export default 'Update {0} selected items';